"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _validate = require("@/utils/validate");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {},
  computed: {
    // 跳转核销商家下拉选项 = 当前已选中的核销供应商列表
    selectedSupplierList: function selectedSupplierList() {
      var ids = this.pram.supplierIdList || [];
      if (ids.length === 0) return [];
      return this.autoList.filter(function (item) {
        return ids.includes(item.id);
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      brandOption: [],
      autoList: [],
      userType: null,
      cardPurposeOptions: [{
        label: '测试卡',
        value: 1
      }, {
        label: '内部员工卡',
        value: 2
      }, {
        label: 'C端福卡',
        value: 3
      }, {
        label: 'B端福卡',
        value: 4
      }]
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res, JavaInfo;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.searchBrand('');
            _context.n = 1;
            return fudouActiveApi.autoListByType({
              type: 4
            });
          case 1:
            res = _context.v;
            console.log(res, 'res');
            this.autoList = res;

            // 获取用户类型
            try {
              JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
              this.userType = JavaInfo.type;
            } catch (e) {
              this.userType = null;
            }
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    throttle: _throttle.default,
    // 验证核销跳转地址
    validateOfflineJumpId: function validateOfflineJumpId(rule, value, callback) {
      // 如果核销供应商有值，则核销跳转地址必填
      if (this.pram.supplierIdList && this.pram.supplierIdList.length > 0) {
        if (!value || value === '') {
          callback(new Error('请填写核销跳转地址ID'));
          return;
        }
      }
      callback();
    },
    openInit: function openInit(tagDetails) {
      var _tagDetails$channelId,
        _chList,
        _chList2,
        _this = this;
      var chList = (tagDetails === null || tagDetails === void 0 ? void 0 : (_tagDetails$channelId = tagDetails.channelIds) === null || _tagDetails$channelId === void 0 ? void 0 : _tagDetails$channelId.split(',')) || [];
      chList = (_chList = chList) === null || _chList === void 0 ? void 0 : _chList.filter(function (item) {
        return item;
      });
      this.pram = _objectSpread(_objectSpread({}, tagDetails), {}, {
        channelIds: (_chList2 = chList) === null || _chList2 === void 0 ? void 0 : _chList2.map(function (item) {
          return Number(item);
        })
      });
      if (this.pram.cardPurpose !== undefined && this.pram.cardPurpose !== null && this.pram.cardPurpose !== '') {
        this.pram.cardPurpose = Number(this.pram.cardPurpose);
      }

      // 根据appId设置appName用于回显
      if (this.pram.appId && this.miniProgramList.length > 0) {
        var miniProgram = this.miniProgramList.find(function (item) {
          return item.id === _this.pram.appId;
        });
        if (miniProgram) {
          this.pram.appName = miniProgram.appName;
          console.log('编辑回显: 根据appId', this.pram.appId, '设置appName为:', this.pram.appName);
        }
      }
      console.log(this.pram, 'this.pram');
      console.log('miniProgramList in editCard:', this.miniProgramList);
      this.visible = true;
    },
    // 处理小程序选择变更
    handleAppChange: function handleAppChange(appName) {
      if (!appName) {
        // 如果清空选择，则清空appId
        this.pram.appId = '';
      } else {
        // 根据appName查找对应的appId
        var miniProgram = this.miniProgramList.find(function (item) {
          return item.appName === appName;
        });
        if (miniProgram) {
          this.pram.appId = miniProgram.id;
          console.log('选择小程序:', appName, '对应ID:', miniProgram.id);
        }
      }
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref = _this2.pram || {},
          cardName = _ref.cardName,
          shortName = _ref.shortName,
          cardPurpose = _ref.cardPurpose,
          _ref$channelIds = _ref.channelIds,
          channelIds = _ref$channelIds === void 0 ? [] : _ref$channelIds,
          id = _ref.id,
          remark = _ref.remark,
          status = _ref.status,
          priority = _ref.priority,
          styleImg = _ref.styleImg,
          isCombo = _ref.isCombo,
          color = _ref.color,
          borderColor = _ref.borderColor,
          backgroundColor = _ref.backgroundColor,
          textColor = _ref.textColor,
          innerRemark = _ref.innerRemark,
          supplierIdList = _ref.supplierIdList,
          offlineJumpId = _ref.offlineJumpId,
          appId = _ref.appId,
          turnMerchant = _ref.turnMerchant;
        fudouActiveApi.cardAddArticle({
          cardName: cardName,
          shortName: shortName,
          cardPurpose: cardPurpose,
          channelIds: channelIds === null || channelIds === void 0 ? void 0 : channelIds.join(','),
          id: id,
          remark: remark,
          status: status,
          priority: priority,
          styleImg: styleImg,
          isCombo: Boolean(isCombo),
          color: color,
          borderColor: borderColor,
          backgroundColor: backgroundColor,
          textColor: textColor,
          innerRemark: innerRemark,
          supplierIdList: supplierIdList,
          offlineJumpId: offlineJumpId,
          appId: appId,
          turnMerchant: turnMerchant
        }).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      fudouActiveApi.selectChannel(keyword).then(function (res) {
        _this3.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchBrand(data);
      }, 300)();
    },
    changeBrand: function changeBrand() {
      var _this$pram;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.brandId)) {
        this.searchBrand('');
      }
      ;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this5 = this;
      this.$modalUpload(function (img) {
        _this5.$set(_this5.pram, dataIndex, img[0].attDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    },
    // 本地上传前的校验
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理本地上传
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options, fieldName) {
        var file, formData, params, loading, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 1;
              _context2.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context2.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.pram, fieldName, res.url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x, _x2) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  },
  props: {
    miniProgramList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};